import { Box, BoxProps, ColorOptions, MaterialTextInput, Spacer, Text, TextProps } from '@jfs/ui-new'
import { Icon } from '@jfs/ui-new/src/comps/IconNew'
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs'
import { NavigationContainer, NavigationIndependentTree, useNavigation } from '@react-navigation/native'
import { flatten } from 'lottie-colorify'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import Lottie from 'react-lottie'
import { TextInput as RNTextInput, TouchableOpacity, View } from 'react-native'
import Animated from 'react-native-reanimated'
import { CustomSectionList } from '../../comps/CustomSectionList'
import { Modal } from '../../comps/Modal'
import { ModalHeader } from '../../comps/ModalHeader'
import { PaySecurelyButton } from '../../comps/PaySecurelyButton'
import { CardType } from '../../data/models/Card'
import { CardlessEMIType } from '../../data/models/CardlessEMI'
import { EMIType } from '../../data/models/EMI'
import { useLazyApiData, useStores } from '../../data/store'
import { CardVendors, convertHexToRGBA, isIE, isIFrame, isValidColorCode } from '../../utils'
import {
  CARD_ELIGIBLE,
  EMI_CARDTYPE,
  EMI as EMIPaymentType,
  pages,
  PAYMENT_MODE_SUBTYPES,
  PAYMENT_MODE_TYPE,
  THEME_PADDING,
  windowConfig,
} from '../../utils/constants'
import { staticStrings } from '../../utils/string'
import { MobileProcessing } from '../PaymentProcesseing/MobileProcessing'
import { CardEMIPlans } from './CardEMIPlans'
import { CarldlessEMI } from './CardLessEMI'
import { DCEMI } from './DCEMI'
import EMIItem from './EMIItem'
import { EMIPlans } from './EMIPlans'
import { ModalCard } from './ModalCard'
import { SelectTenureCardless } from './SelectTenureCardless'
export const IS_DEBIT_CARD_ENABLED = true
const loader = require('../../assets/images/pg_loader.json')
const EMI: FC = () => {
  const {
    theme,
    getAllEMIList,
    cardLessEMIList,
    binService,
    amount,
    emiList,
    addPaymentMethod,
    getCardEligibility,
    getCardLessEMIList,
    getCardLessEMIPlans,
    getCardLessEMIBank,
    getCardEMIPlans,
    applyOffer,
    validateOffer,
    offerApplied,
    updateIsOfferApplied,
    getBankEmiId,
    // isValidBankEMIId,
    // getEMITransactionAmount,
    getEMIOfferPaymentModes,
    selectedOfferPMType,
    getEmiPlanCount,
    isDCExternalScheme,
    mobileNumber,
    isValidOffer,
    preProcess,
    getSavedCards,
    savedCardApiStatus,
    savedCard,
    uniqueWindowId,
  } = useStores((root) => ({
    uniqueWindowId: root.config.uniqueWindowId,
    getAllEMIList: root.getAllEMIList,
    cardLessEMIList: root.merchant.preferences.cardLessEMIList,
    theme: root?.config?.merchantTheme,
    emiList: root.merchant.preferences.EMILList,
    binService: root.binServiceApi,
    amount: root.getTransactionAmount(),
    addPaymentMethod: root.transaction.addPaymentMethod,
    getCardEligibility: root.getCardEligibility,
    getCardLessEMIList: root.getCardLessEMIList,
    getCardLessEMIPlans: root.getCardLessEMIPlans,
    getCardLessEMIBank: root.getCardLessEMIBank,
    getCardEMIPlans: root.getCardEMIPlans,
    applyOffer: root.offerTxnApplyApi,
    validateOffer: root.offerValidateApi,
    offerApplied: root.isOfferApplied,
    updateIsOfferApplied: root.transaction.updateIsOfferApplied,
    getBankEmiId: root.getBankEMIID,
    getEMIOfferPaymentModes: root.getEMIOfferPaymentModes,
    selectedOfferPMType: root.transaction.selectedOfferPMType,
    getEmiPlanCount: root.getEmiPlanCount,
    isDCExternalScheme: root.isDCExternalScheme,
    mobileNumber: root.transaction.payer.number,
    isValidOffer: root.transaction.isValidOffer,
    preProcess: root.preProcessApi,
    getSavedCards: root.getSavedCards,
    savedCardApiStatus: root.config.savedCardApiStatus,
    savedCard: root?.user?.paymentMethod,
  }))

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: isValidColorCode(theme?.brandColor) ? flatten(theme?.brandColor, loader) : loader,
  }
  const [showPaymentProcessModal, setShowPaymentProcessModal] = useState(false)
  const [showCardModal, setShowCardModal] = useState(false)
  const [allEMIPlansOpen, setAllEmiPlansOpen] = useState(false)
  const [isCardEMIPlanSelected, setIsCardEMIPlanSelected] = useState(false)
  const [emiPlansAvailable, setEMIPlansAvailable] = useState('')
  const navigation = useNavigation()
  const [showCardLessEMI, setShowCardLessEMI] = useState(false)
  const [showDCEMI, setShowDCEMI] = useState(false)
  const [showCardEMIPlans, setShowCardEMIPlans] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [dcBankId, setDCBankId] = useState('')
  const [errorColor, setErrorColor] = useState('')
  const [isValidMobileNumber, setIsValidMobileNumber] = useState(false)
  const [mobile, setMobile] = useState(mobileNumber)
  const [open, setOpen] = useState(false)
  const [showTenurePlan, setShowTenurePlan] = useState(false)
  const [selectedEmi, setSelectedEMI] = useState({
    bank: '',
    bankName: '',
    planSource: '0',
    tenure: '',
  })

  const isOfferApplied = offerApplied(PAYMENT_MODE_SUBTYPES.CARD, PAYMENT_MODE_TYPE.EMI)

  const postDataRef = useRef<any>()

  const { navigate } = useNavigation()
  const [lazyGetEMIList, { state: lazyGetEMIListState }] = useLazyApiData(getAllEMIList)
  const [lazyApplyOffer, { state: applyOfferState }] = useLazyApiData(applyOffer)
  const [validateOfferApi, { state: validateOfferState }] = useLazyApiData(validateOffer)
  const [lazyPreProcessApi, { state: preProcessApiState }] = useLazyApiData(preProcess)

  const [binServiceApi, { state: binServiceState, data: binServiceData }] = useLazyApiData(binService)
  const [lazyGetCardEligibility, { state: getCardEligibilityState, data: getCardEligibilityData }] =
    useLazyApiData(getCardEligibility)

  const { REACT_APP_URL = '', REACT_APP_ENDPOINT = '' } = process.env

  const loadProcessingScreen = useCallback(() => {
    const loaderUrl = REACT_APP_ENDPOINT
      ? `${REACT_APP_URL}/${REACT_APP_ENDPOINT}/loader.html`
      : `${REACT_APP_URL}/loader.html`
    if (!isIFrame()) {
      window.currentChild = window
    } else {
      window.currentChild = window.open(loaderUrl, `jiopayWindow-${uniqueWindowId}`, windowConfig)
      window.currentChild?.focus()
    }
    setShowPaymentProcessModal(true)
  }, [REACT_APP_ENDPOINT, REACT_APP_URL, uniqueWindowId])

  useEffect(() => {
    if (applyOfferState === 'fulfilled') {
      loadProcessingScreen()
    } else if (applyOfferState === 'rejected') {
      const cardNo = postDataRef.current.pan
      const schemeSubType = '00'
      setErrMsg(staticStrings.offerError)
      lazyGetCardEligibility(cardNo, true, schemeSubType)
      setIsCardEMIPlanSelected(false)
      setEMIPlansAvailable('')
      setIsCardEMIPlanSelected(false)
    }
  }, [applyOfferState, lazyGetCardEligibility, loadProcessingScreen])

  useEffect(() => {
    if (validateOfferState === 'rejected') {
      setErrMsg(staticStrings.offerError)
    }
  }, [validateOfferState])

  useEffect(() => {
    if (getCardEligibilityState === 'fulfilled') {
      const data = getCardEligibilityData
      console.log('getCardEligibilityState1', data)
      if (data.length > 0) {
        setEMIPlansAvailable(CARD_ELIGIBLE.eligible)
      } else {
        setEMIPlansAvailable(CARD_ELIGIBLE.not_eligible)
      }
    } else if (getCardEligibilityState === 'rejected') {
      const isNewCard = postDataRef?.current?.isNewCard
      if (isNewCard) {
        setEMIPlansAvailable(CARD_ELIGIBLE.not_eligible)
      }
    }
  }, [getBankEmiId, getCardEligibilityData, getCardEligibilityState, navigate, validateOfferApi])

  useEffect(() => {
    if (binServiceState === 'rejected') {
      setErrMsg(staticStrings.NotValidCard)
    }
  }, [binServiceState])

  useEffect(() => {
    if (cardLessEMIList.length === 0 || emiList.length === 0) {
      lazyGetEMIList()
    }
  }, [cardLessEMIList.length, emiList, lazyGetEMIList])

  const navigatePayment = useCallback(() => {
    if (isOfferApplied && applyOfferState !== 'rejected' && isValidOffer) {
      lazyApplyOffer()
    } else {
      updateIsOfferApplied(false)
      loadProcessingScreen()
    }
  }, [applyOfferState, isOfferApplied, isValidOffer, lazyApplyOffer, loadProcessingScreen, updateIsOfferApplied])
  useEffect(() => {
    if (preProcessApiState === 'fulfilled') {
      handleOpen(false)
      if (selectedEmi.planSource === '2') {
        const emi: CardlessEMIType = getCardLessEMIBank(selectedEmi.bank, selectedEmi.tenure)
        addPaymentMethod(emi)
        navigatePayment()
      } else {
        setShowTenurePlan(true)
      }
    } else if (preProcessApiState === 'rejected') {
      handleOpen(false)
    }
  }, [addPaymentMethod, navigatePayment, cardLessEMIList, getCardLessEMIBank, preProcessApiState, selectedEmi])

  useEffect(() => {
    if (savedCardApiStatus === 'initial') {
      getSavedCards()
    }
  }, [getSavedCards, savedCardApiStatus])

  const onCadModalDismiss = () => {
    setShowCardModal(!showCardModal)
    setShowDCEMI(false)
    setEMIPlansAvailable('')
  }

  const onCardNumberBlur = useCallback(
    (cardVendor: CardVendors, cardNumber: string) => {
      //If it is new PG and if there is no error then only we have to call binservice
      console.log('cardVendor', cardVendor)
      binServiceApi(cardNumber)
      postDataRef.current = {
        ...postDataRef.current,
        pan: cardNumber,
        isNewCard: true,
      }
      const cardBin = cardNumber.replace(/[^0-9]/g, '').slice(0, 6)
      if (getCardEMIPlans(cardBin, '01', EMIPaymentType.CARD_EMI).length === 0) {
        lazyGetCardEligibility(cardBin, true, '01', amount, dcBankId)
      } else {
        setEMIPlansAvailable(CARD_ELIGIBLE.eligible)
      }
      console.log('cardVendor1', cardVendor)
    },
    [amount, binServiceApi, dcBankId, getCardEMIPlans, lazyGetCardEligibility],
  )

  const handleProceed = async () => {
    const postData = postDataRef.current
    const cardInfo = binServiceData
    const [expmon, expyr] = postData?.expdate.split('/')
    const newCardEmi = postData?.newCard
    if (emiPlansAvailable === CARD_ELIGIBLE.eligible) {
      const products = newCardEmi.product.map((item: any) => {
        return {
          emiPlan: {
            allowZeroCost: item.emiPlan.allowZeroCost,
            bankInterestRate: item.emiPlan.bankInterestRate,
            bankInterestRatePercentage: item.emiPlan.bankInterestRatePercentage,
            additionalCashback: item.emiPlan.additionalCashback,
            productDiscount: item.emiPlan.productDiscount,
            productDiscountPercentage: item.emiPlan.productDiscountPercentage,
            programType: item.emiPlan.programType,
            scheme: item.emiPlan.scheme,
            subventionCashbackDiscount: item.emiPlan.subventionCashbackDiscount,
            subventionCashbackDiscountPercentage: item.emiPlan.subventionCashbackDiscountPercentage,
          },
          productAmount: item.productAmount,
          productId: item.productId,
        }
      })

      const newEMI = {
        bank: newCardEmi?.bank,
        tenure: newCardEmi?.tenure,
        scheme: newCardEmi?.scheme,
        value: newCardEmi?.emi,
        metadata: newCardEmi?.metadata,
        interest: newCardEmi?.interest,
        schemeSubType: newCardEmi?.schemeSubType,
        netAmount: newCardEmi?.netAmount,
        discount: newCardEmi?.discount,
        product: products,
        interestRate: newCardEmi?.interestRate,
        processingFee: newCardEmi?.processingFee,
        processingFeeTax: newCardEmi?.processingFeeTax,
        convenienceFee: newCardEmi?.convenienceFee,
        convenienceFeeTax: newCardEmi?.convenienceFeeTax,
        cashBack: newCardEmi?.cashBack,
        mobileNumber: postData?.mobileNumber,
        card: {
          number: postData?.pan,
          type: postData?.cardType,
          cvv: String(postData?.cvv),
          subType: String(cardInfo?.type ?? ''),
          ownerName: postData?.name,
          expmon: Number(expmon),
          expyr: Number(expyr),
          expDate: postData?.expdate,
          id: 0,
          scheme: String(cardInfo?.scheme ?? ''),
          isSave: postData?.isSave,
        },
        paymentType: 'EMI',
      } as EMIType
      addPaymentMethod(newEMI)
      navigatePayment()
    } else if (emiPlansAvailable === CARD_ELIGIBLE.not_eligible) {
      const newCard = {
        number: postData?.pan,
        type: postData?.cardType,
        cvv: String(postData?.cvv),
        subType: String(cardInfo?.type ?? ''),
        ownerName: postData?.name,
        expmon: Number(expmon),
        expyr: Number(expyr),
        expDate: postData?.expdate,
        id: 0,
        scheme: String(cardInfo?.scheme ?? ''),
        isSave: postData?.isSave,
        paymentType: 'Card',
      } as CardType
      addPaymentMethod(newCard)
      navigatePayment()
    }
  }

  const onCardPayment = ({ cardNumber, cardHolderName, expiry, cvv, isSaveCard }: any) => {
    postDataRef.current = {
      ...postDataRef.current,
      pan: cardNumber,
      name: cardHolderName,
      cvv: cvv,
      isSave: isSaveCard,
      expdate: expiry,
      cardType: 'DEBITCARD',
    }
    console.log('onCardPayment', postDataRef.current)
    handleProceed()
  }

  const onDismiss = () => {
    setShowCardEMIPlans(false)
  }

  const onCardNumberChange = (cardNumber: string) => {
    if (isCardEMIPlanSelected) {
      setIsCardEMIPlanSelected(!isCardEMIPlanSelected)
    }
    if (emiPlansAvailable === CARD_ELIGIBLE.eligible || emiPlansAvailable === CARD_ELIGIBLE.not_eligible) {
      setEMIPlansAvailable('')
    }
    if (errMsg && cardNumber) {
      setErrMsg('')
    }
  }

  const onClickCardLessItem = (selectedItem: any) => {
    setSelectedEMI({
      bank: selectedItem.id,
      bankName: selectedItem.text,
      planSource: selectedItem.planSource,
      tenure: selectedItem.tenure,
    })
    setOpen(true)
  }

  const renderEMIItem = ({ item, index }: { item: any; index: number }) => {
    console.log('renderEMIItem', item)
    return (
      <Box testID={`cardEMIItem${index}`}>
        <EMIItem
          type={'DEFAULT_CARD'}
          title={item.text}
          subTitle={'Buy now and pay later in EMIs'}
          onClick={() => onClickCardLessItem(item)}
        />
        <Box {...style.separatorStyle} />
      </Box>
    )
  }

  const style = styles(theme)

  if (lazyGetEMIListState === 'pending' || savedCardApiStatus === 'initial' || savedCardApiStatus === 'pending') {
    return (
      <Box flex={1} backgroundColor={theme.bodyBgColor as ColorOptions} justifyContent="center" alignItems="center">
        <Lottie options={defaultOptions} height={60} width={60} />
        <Spacer size={5} />
        <Text fontSize={14} fontWeight="700" color={theme.bodyTextColor as ColorOptions}>
          Fetching EMI Plans
        </Text>
      </Box>
    )
  }

  const onClickCardFooter = () => {
    setShowCardEMIPlans(true)
  }

  const onEMIPlanSelected = (item: any, isValidOffer: boolean) => {
    if (isOfferApplied) {
      if (isValidOffer) {
        setErrMsg('Offer Applied')
        setErrorColor(theme.brandColor)
      } else {
        setErrMsg(staticStrings.offerError)
        setErrorColor(theme.brandColor)
      }
    }

    const products = item.product.map((item: any) => item)

    postDataRef.current = {
      ...postDataRef.current,
      newCard: {
        bank: item.bank,
        tenure: item.tenure,
        scheme: item.scheme,
        schemeSubType: item.schemeSubType,
        emi: item.emi,
        metadata: item.metadata,
        totalAmount: item.totalAmount,
        netAmount: item.netAmount,
        interest: item.interest,
        interestRate: item.interestRate,
        processingFee: item.processingFee,
        discount: item.discount,
        product: products,
        processingFeeTax: item.processingFeeTax,
        convenienceFee: item.convenienceFee,
        convenienceFeeTax: item.convenienceFeeTax,
        cashBack: item.cashBack,
      },
    }

    console.log('onEMIPlanSelected', postDataRef.current)
    setShowCardEMIPlans(!showCardEMIPlans)

    setIsCardEMIPlanSelected(true)
  }

  const creditEmiAvailable = getEmiPlanCount(EMIPaymentType.CREDIT_CARD_ALL) > 0
  const debitEmiAvailable = getEmiPlanCount(EMIPaymentType.DEBIT_CARD_ALL) > 0
  const cardlessEmiAvailable = getEmiPlanCount(EMIPaymentType.CARDLESS) > 0

  const OfferEligiblePaymentMode = () => {
    const { offerList } = getEMIOfferPaymentModes()
    return (
      <>
        {offerList.includes(EMI_CARDTYPE.CREDIT_CARD) && creditEmiAvailable && (
          <Box>
            <EMIItem
              type={'DEFAULT_CARD'}
              title={'Credit Cards'}
              subTitle={'EMIs on your credit cards'}
              onClick={() => navigation.navigate(pages.emicard)}
            />
            <Box {...style.separatorStyle} />
          </Box>
        )}

        {offerList.includes(EMI_CARDTYPE.DEBIT_CARD) && debitEmiAvailable && (
          <Box>
            <EMIItem
              type={'DEFAULT_CARD'}
              title={'Debit Cards'}
              subTitle={'EMIs on your debit cards'}
              onClick={() => setShowDCEMI(true)}
            />
            <Box {...style.separatorStyle} />
          </Box>
        )}

        {offerList.includes(EMI_CARDTYPE.CARDLESS) && cardlessEmiAvailable && (
          <Box>
            <Box
              paddingHorizontal={THEME_PADDING.HORIZONTAL_PADDING}
              paddingTop={THEME_PADDING.VERTICAL_PADDING}
              flexDirection="row"
              justifyContent="space-between">
              <Text {...style.text}>Cardless EMIs</Text>
            </Box>
            <Spacer size={20} />

            <CustomSectionList data={getCardLessEMIList()} renderItem={renderEMIItem} />
          </Box>
        )}
      </>
    )
  }

  const withOutOfferPaymentMode = () => {
    const { withoutOffersList } = getEMIOfferPaymentModes()
    return (
      <>
        <Box paddingHorizontal={24} paddingTop={24}>
          <Text {...style.payWithOutText}>PAY WITHOUT OFFER</Text>
        </Box>
        <Spacer size={10} />
        {withoutOffersList.includes(EMI_CARDTYPE.CREDIT_CARD) && creditEmiAvailable && (
          <Box>
            <EMIItem
              type={'DEFAULT_CARD'}
              title={'Credit Cards'}
              subTitle={'EMIs on your credit cards'}
              onClick={() => navigation.navigate(pages.emicard)}
            />
            <Box {...style.separatorStyle} />
          </Box>
        )}
        {withoutOffersList.includes(EMI_CARDTYPE.DEBIT_CARD) && debitEmiAvailable && (
          <Box>
            <EMIItem
              type={'DEFAULT_CARD'}
              title={'Debit Cards'}
              subTitle={'EMIs on your debit cards'}
              onClick={() => setShowDCEMI(true)}
            />
            <Box {...style.separatorStyle} />
          </Box>
        )}
        {withoutOffersList.includes(EMI_CARDTYPE.CARDLESS) && cardlessEmiAvailable && (
          <>
            <Box
              paddingHorizontal={THEME_PADDING.HORIZONTAL_PADDING}
              paddingTop={THEME_PADDING.VERTICAL_PADDING}
              flexDirection="row"
              justifyContent="space-between">
              <Text {...style.text}>Cardless EMIs</Text>
            </Box>
            <Spacer size={20} />

            <CustomSectionList data={getCardLessEMIList()} renderItem={renderEMIItem} />
          </>
        )}
      </>
    )
  }

  const handleOpen = (open: boolean) => {
    setOpen(open)
  }

  const onChangeMobileNo = (value: string) => {
    setMobile(value)
  }

  const handleTenureDismiss = () => {
    setShowTenurePlan(false)
  }

  const onEmiTenureSubmit = (item: any) => {
    handleTenureDismiss()
    const emi: CardlessEMIType = getCardLessEMIBank(item.bank, item.tenure)
    addPaymentMethod(emi)
    navigatePayment()
  }

  const onClickProceed = () => {
    if (mobile) {
      const params = {
        number: mobile,
      }
      const payerInfo = {
        id: selectedEmi?.bank,
        text: selectedEmi?.bankName,
      }
      lazyPreProcessApi(params, payerInfo, true)
    }
  }

  const onCardPress = (type: string) => {
    const savedCardList = savedCard?.filter((card: any) => card?.type === type)
    console.log('offerApplied', offerApplied)
    if (!isOfferApplied && savedCardList?.length > 0) {
      setShowDCEMI(false)
      navigation.navigate(pages.emiSavedCard as never, { type } as never)
    } else if (type === 'DEBITCARD') {
      setShowCardModal(true)
    } else {
      navigation.navigate(pages.emicard as never)
    }
  }

  if (selectedOfferPMType === PAYMENT_MODE_TYPE.EMI) {
    return (
      <Box {...style.container}>
        <Box
          paddingHorizontal={THEME_PADDING.HORIZONTAL_PADDING}
          paddingTop={THEME_PADDING.VERTICAL_PADDING}
          flexDirection="row"
          justifyContent="space-between">
          <Text {...style.text}>Pay Using</Text>
          <Box
            underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
            onPress={() => setAllEmiPlansOpen(true)}>
            <Text {...style.emiPlans}>EMI Plans</Text>
          </Box>
        </Box>
        <Spacer size={20} />
        {getEMIOfferPaymentModes()?.offerList?.length > 0 && OfferEligiblePaymentMode()}
        {getEMIOfferPaymentModes()?.withoutOffersList?.length > 0 && withOutOfferPaymentMode()}
        <DCEMI
          show={showDCEMI}
          onClose={() => setShowDCEMI(false)}
          setDCBankId={setDCBankId}
          setShowCardModal={setShowCardModal}
          setShowPaymentProcessModal={setShowPaymentProcessModal}
        />
        <CarldlessEMI
          show={showCardLessEMI}
          onClose={() => setShowCardLessEMI(false)}
          setShowPaymentProcessModal={setShowPaymentProcessModal}
        />
        {showPaymentProcessModal && (
          <MobileProcessing setShow={setShowPaymentProcessModal} show={showPaymentProcessModal} />
        )}
        {allEMIPlansOpen && <AllEMIPlans open={allEMIPlansOpen} setOpen={setAllEmiPlansOpen} />}

        {showCardModal && (
          <ModalCard
            show={showCardModal}
            onDismiss={onCadModalDismiss}
            onPayment={(values) => {
              onCardPayment(values)
            }}
            isLoading={validateOfferState === 'pending' || applyOfferState === 'pending' ? true : false}
            onCardNumberBlur={onCardNumberBlur}
            onCardNumberChange={onCardNumberChange}
            amount={amount}
            isValid={binServiceData?.scheme ?? false}
            fotterComp={
              emiPlansAvailable === CARD_ELIGIBLE.eligible ? (
                <EMIEligibilityFooter
                  title={
                    !isCardEMIPlanSelected
                      ? 'Select a EMI Plan'
                      : `₹${postDataRef?.current?.newCard?.emi} X ${postDataRef?.current?.newCard?.tenure} | ${postDataRef?.current?.newCard?.interestRate}% p.a`
                  }
                  onClick={onClickCardFooter}
                />
              ) : (
                emiPlansAvailable === CARD_ELIGIBLE.not_eligible && <EMINotEligibileFooter />
              )
            }
            addlFotterComp={
              emiPlansAvailable === CARD_ELIGIBLE.eligible &&
              isDCExternalScheme(postDataRef?.current?.pan.replace(/[^0-9]/g, '').slice(0, 6), '01') && (
                <MobileNumber
                  theme={theme}
                  isValidMobileNumber={setIsValidMobileNumber}
                  mobileNumber={String(mobileNumber)}
                  onChange={(number: string) => {
                    postDataRef.current = {
                      ...postDataRef.current,
                      mobileNumber: number,
                    }
                  }}
                />
              )
            }
            errorColor={errorColor as ColorOptions}
            errMsg={errMsg}
            theme={theme}
            isEMI={true}
            isPayButtonEnable={
              isDCExternalScheme(postDataRef?.current?.pan.replace(/[^0-9]/g, '').slice(0, 6), '01')
                ? isValidMobileNumber && isCardEMIPlanSelected
                : isCardEMIPlanSelected
            }
            isEMIPlanSelected={isCardEMIPlanSelected}
            isEMIEligible={emiPlansAvailable === CARD_ELIGIBLE.eligible ? true : false}
          />
        )}
        {showCardEMIPlans && (
          <CardEMIPlans
            theme={theme}
            bankId={dcBankId}
            schemeSubType="01"
            cardNo={postDataRef.current.pan}
            onEMIPlanSelected={(item: any, isValidOffer: boolean) => {
              onEMIPlanSelected(item, isValidOffer)
            }}
            onDismiss={onDismiss}
          />
        )}
      </Box>
    )
  }

  return (
    <Box {...style.container}>
      <Box
        paddingHorizontal={THEME_PADDING.HORIZONTAL_PADDING}
        paddingTop={THEME_PADDING.VERTICAL_PADDING}
        flexDirection="row"
        justifyContent="space-between">
        <Text {...style.text}>Pay Using</Text>
        {(creditEmiAvailable || debitEmiAvailable) && (
          <Box
            underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
            onPress={() => setAllEmiPlansOpen(true)}>
            <Text {...style.emiPlans}>EMI Plans</Text>
          </Box>
        )}
      </Box>
      <Spacer size={20} />
      {creditEmiAvailable && (
        <Box>
          <EMIItem
            type={'DEFAULT_CARD'}
            title={'Credit Cards'}
            subTitle={'EMIs on your credit cards'}
            onClick={() => onCardPress('CREDITCARD')}
          />
          <Box {...style.separatorStyle} />
        </Box>
      )}
      {debitEmiAvailable && (
        <Box>
          <EMIItem
            type={'DEFAULT_CARD'}
            title={'Debit Cards'}
            subTitle={'EMIs on your debit cards'}
            onClick={() => setShowDCEMI(true)}
          />
          <Box {...style.separatorStyle} />
        </Box>
      )}
      {cardlessEmiAvailable && (
        <Box>
          <Box
            paddingHorizontal={THEME_PADDING.HORIZONTAL_PADDING}
            paddingTop={THEME_PADDING.VERTICAL_PADDING}
            flexDirection="row"
            justifyContent="space-between">
            <Text {...style.text}>Cardless EMIs</Text>
          </Box>
          <Spacer size={20} />
          <CustomSectionList data={getCardLessEMIList()} renderItem={renderEMIItem} />
        </Box>
      )}
      <DCEMI
        show={showDCEMI}
        onClose={() => {
          setShowDCEMI(false)
        }}
        setDCBankId={setDCBankId}
        setShowCardModal={() => onCardPress('DEBITCARD')}
        setShowPaymentProcessModal={setShowPaymentProcessModal}
      />

      <CarldlessEMI
        show={showCardLessEMI}
        onClose={() => setShowCardLessEMI(false)}
        setShowPaymentProcessModal={setShowPaymentProcessModal}
      />

      {showPaymentProcessModal && (
        <MobileProcessing setShow={setShowPaymentProcessModal} show={showPaymentProcessModal} />
      )}
      {allEMIPlansOpen && <AllEMIPlans open={allEMIPlansOpen} setOpen={setAllEmiPlansOpen} />}
      {showCardModal && (
        <ModalCard
          show={showCardModal}
          onDismiss={onCadModalDismiss}
          onPayment={(values) => {
            onCardPayment(values)
          }}
          isLoading={validateOfferState === 'pending' || applyOfferState === 'pending' ? true : false}
          onCardNumberBlur={onCardNumberBlur}
          onCardNumberChange={onCardNumberChange}
          amount={amount}
          isValid={binServiceData?.scheme ?? false}
          fotterComp={
            emiPlansAvailable === CARD_ELIGIBLE.eligible ? (
              <EMIEligibilityFooter
                title={
                  !isCardEMIPlanSelected
                    ? 'Select a EMI Plan'
                    : `₹${postDataRef?.current?.newCard?.emi} X ${postDataRef?.current?.newCard?.tenure} | ${postDataRef?.current?.newCard?.interestRate}% p.a`
                }
                onClick={onClickCardFooter}
              />
            ) : (
              emiPlansAvailable === CARD_ELIGIBLE.not_eligible && <EMINotEligibileFooter />
            )
          }
          addlFotterComp={
            emiPlansAvailable === CARD_ELIGIBLE.eligible &&
            isDCExternalScheme(postDataRef?.current?.pan.replace(/[^0-9]/g, '').slice(0, 6), '01') && (
              <MobileNumber
                theme={theme}
                isValidMobileNumber={setIsValidMobileNumber}
                mobileNumber={String(mobileNumber)}
                onChange={(number: string) => {
                  postDataRef.current = {
                    ...postDataRef.current,
                    mobileNumber: number,
                  }
                }}
              />
            )
          }
          errMsg={errMsg}
          theme={theme}
          isEMI={true}
          isPayButtonEnable={
            isDCExternalScheme(postDataRef?.current?.pan.replace(/[^0-9]/g, '').slice(0, 6), '01')
              ? isValidMobileNumber && isCardEMIPlanSelected
              : isCardEMIPlanSelected
          }
          isEMIEligible={emiPlansAvailable === CARD_ELIGIBLE.eligible ? true : false}
        />
      )}
      {showCardEMIPlans && (
        <CardEMIPlans
          theme={theme}
          schemeSubType="01"
          bankId={dcBankId}
          cardNo={postDataRef.current.pan}
          onEMIPlanSelected={(item: any, msg: any) => {
            onEMIPlanSelected(item, msg)
          }}
          onDismiss={onDismiss}
        />
      )}

      <Modal
        type={'Bottom'}
        show={open}
        onDismiss={() => handleOpen(false)}
        theme={theme}
        containerTopPadding={isIE() ? 5 : undefined}>
        <>
          <Box
            backgroundColor={theme.bodyBgColor as ColorOptions}
            justifyContent="space-between"
            flexDirection="row"
            marginHorizontal={16}
            marginVertical={22}>
            <Text fontWeight={'700'} fontSize={14} color={theme.bodyTextColor as ColorOptions} align-self={true}>
              {selectedEmi.bankName}
            </Text>
            <Box
              onPress={() => handleOpen(false)}
              underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}>
              <Icon id={'CLOSE'} size={16} color={theme?.brandColor as ColorOptions} />
            </Box>
          </Box>
          <Box marginHorizontal={24} marginVertical={16}>
            <MaterialTextInput
              autoFocus={false}
              maxLength={10}
              value={mobile}
              onChangeText={onChangeMobileNo}
              placeholder={'Enter Mobile Number'}
              placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
              keyboardType={'number-pad'}
              color={theme?.bodyTextColor as ColorOptions}
              testID={'mobileNumber'}
              bottomLineColor={theme?.brandColor as ColorOptions}
              tintColor={theme?.brandColor as ColorOptions}
            />
            <Spacer size={20} />
            <Box>
              <PaySecurelyButton
                disabled={mobile.length >= 10 ? false : true}
                amount={amount}
                testID={'cardLessEMIPaySecurelyBtn'}
                onPress={onClickProceed}
                isLoading={preProcessApiState === 'pending' ? true : false}
              />
            </Box>
          </Box>
        </>
      </Modal>

      <Modal
        type={'BottomTop'}
        show={showTenurePlan}
        onDismiss={handleTenureDismiss}
        theme={theme}
        containerTopPadding={isIE() ? 5 : undefined}>
        <>
          <ModalHeader title={'Select EMI Tenure'} onDismiss={handleTenureDismiss} theme={theme} />

          <SelectTenureCardless data={getCardLessEMIPlans(selectedEmi?.bank)} onEmiTenureSubmit={onEmiTenureSubmit} />
        </>
      </Modal>
    </Box>
  )
}

function TabBar({
  state,
  descriptors,
  navigation,
  theme,
}: {
  state: any
  descriptors: any
  navigation: any
  theme: any
}) {
  return (
    <View style={{ flexDirection: 'row' }}>
      {state.routes.map((route: any, index: number) => {
        const { options } = descriptors[route.key]
        const label =
          options.tabBarLabel !== undefined
            ? options.tabBarLabel
            : options.title !== undefined
            ? options.title
            : route.name

        const isFocused = state.index === index

        const onPress = () => {
          const event = navigation.emit({
            type: 'tabPress',
            target: route.key,
            canPreventDefault: true,
          })

          if (!isFocused && !event.defaultPrevented) {
            navigation.navigate(route.name)
          }
        }

        const onLongPress = () => {
          navigation.emit({
            type: 'tabLongPress',
            target: route.key,
          })
        }
        return (
          <View style={{ flex: 1, height: 48 }}>
            <TouchableOpacity
              accessibilityRole="button"
              accessibilityState={isFocused ? { selected: true } : {}}
              accessibilityLabel={options.tabBarAccessibilityLabel}
              testID={options.tabBarTestID}
              onPress={onPress}
              onLongPress={onLongPress}
              style={{ flex: 1, height: 48, alignItems: 'center', justifyContent: 'center' }}>
              <Animated.Text
                style={
                  isFocused
                    ? { color: theme.brandColor, fontSize: 12, fontWeight: 'bold' }
                    : { color: convertHexToRGBA(theme.bodyTextColor, 50), fontSize: 12, fontWeight: '700' }
                }>
                {label}
              </Animated.Text>
            </TouchableOpacity>
            <View
              style={{
                borderBottomColor: isFocused ? theme.brandColor : convertHexToRGBA(theme.bodyTextColor, 10),
                borderBottomWidth: isFocused ? 3 : 1,
              }}
            />
          </View>
        )
      })}
    </View>
  )
}

const MobileNumber = ({
  theme,
  isValidMobileNumber,
  mobileNumber,
  onChange,
}: {
  theme: any
  isValidMobileNumber: (isValid: boolean) => void
  mobileNumber: string
  onChange: (mobileNumber: string) => void
}) => {
  const [errorMsg, setErrorMsg] = useState('')

  const [mobNumber, setMobNumber] = useState(mobileNumber)

  const mobileNumberInputRef = useRef<RNTextInput>(null)

  const onInternalBlur = () => {
    console.log('onInternalBlur mobNumber', mobNumber, mobNumber.length !== 10)
    try {
      if (mobNumber.length !== 10) {
        throw new Error()
      } else if (mobNumber.length === 10) {
        setErrorMsg('')
        isValidMobileNumber(true)
      }
    } catch (error) {
      setErrorMsg('Invalid Mobile Number')
      isValidMobileNumber(false)
    }
  }

  const internalOnChangeCardHolder = useCallback(
    (text: string) => {
      console.log('internalOnChangeCardHolder', text)
      errorMsg && setErrorMsg('')
      const formattedCardHolderName = text.replace(/[^0-9 ]/g, '')
      if (formattedCardHolderName.length === 10) {
        setErrorMsg('')
        isValidMobileNumber(true)
      } else {
        setErrorMsg('Invalid Mobile Number')
        isValidMobileNumber(false)
      }
      onChange(formattedCardHolderName)
      setMobNumber(formattedCardHolderName)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )

  useEffect(() => {
    if (mobNumber === mobileNumber) {
      internalOnChangeCardHolder(mobNumber)
    }
  }, [internalOnChangeCardHolder, mobNumber, mobileNumber])

  return (
    <Box direction={'row'} align={'center'}>
      <MaterialTextInput
        innerRef={mobileNumberInputRef}
        maxLength={10}
        value={mobNumber}
        onChangeText={(text: string) => internalOnChangeCardHolder(text)}
        placeholderTextColor={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions}
        onBlur={onInternalBlur}
        placeholder={'Mobile Number'}
        keyboardType={'name-phone-pad'}
        error={errorMsg}
        testID={'cardHolderName'}
        color={theme?.bodyTextColor}
        bottomLineColor={theme?.brandColor as ColorOptions}
        tintColor={theme?.brandColor as ColorOptions}
      />
    </Box>
  )
}

// const Tab = createMaterialTopTabNavigator()

export const AllEMIPlans = ({ open, setOpen }: { open: boolean; setOpen: (open: boolean) => void }) => {
  const { theme, isCCPlansAllowed, isDCPlansAllowed } = useStores((root) => ({
    theme: root.config.merchantTheme,
    getEmiPlanCount: root.getEmiPlanCount,
    isCCPlansAllowed: root.isCCEMIPlansAllowed,
    isDCPlansAllowed: root.isDCEMIPlansAllowed,
  }))
  const [show, setShow] = useState(open)
  const onDismiss = () => {
    setShow(false)
    setOpen(false)
  }

  const Tab = createMaterialTopTabNavigator()

  const getTabs = () => {
    return (
      <>
        <Tab.Screen name="No Cost EMI" component={NoCostEMIPlans} />
        {isCCPlansAllowed() && <Tab.Screen name="Credit Cards" component={CCAllEMIPlans} />}
        {isDCPlansAllowed() && <Tab.Screen name="Debit Cards" component={DCAllEMIPlans} />}
      </>
    )
  }

  if (!open) {
    return null
  }

  // const showCreditTab = getEmiPlanCount(EMIPaymentType.CREDIT_CARD_ALL) > 0
  // const showDebitTab = getEmiPlanCount(EMIPaymentType.DEBIT_CARD_ALL) > 0
  return (
    <Modal
      type={'BottomTop'}
      headerType="White_Bg"
      show={show}
      onDismiss={onDismiss}
      isFullWidth={true}
      theme={theme}
      containerTopPadding={isIE() ? 5 : undefined}>
      <Box borderTopLeftRadius={16} borderTopRightRadius={16} backgroundColor={theme.bodyBgColor as ColorOptions} f={1}>
        <ModalHeader title="EMI Plan" onDismiss={onDismiss} theme={theme} />
        <NavigationIndependentTree>
          <NavigationContainer>
            <Tab.Navigator
              screenOptions={{ sceneStyle: { backgroundColor: theme.bodyBgColor, flex: 1 } }}
              tabBar={(props) => <TabBar {...props} theme={theme} />}>
              {getTabs()}
            </Tab.Navigator>
          </NavigationContainer>
        </NavigationIndependentTree>
      </Box>
    </Modal>
  )
}

const NoCostEMIPlans = () => {
  const { getEMIPlans } = useStores((root) => ({
    getEMIPlans: root.getEMIPlans,
  }))
  return <EMIPlans plans={getEMIPlans(EMIPaymentType.NO_LOW_COST_EMI_ALL)} />
}

const DCAllEMIPlans = () => {
  const { getEMIPlans } = useStores((root) => ({
    getEMIPlans: root.getEMIPlans,
  }))
  return <EMIPlans plans={getEMIPlans(EMIPaymentType.DEBIT_CARD_ALL)} />
}

const CCAllEMIPlans = () => {
  const { getEMIPlans } = useStores((root) => ({
    getEMIPlans: root.getEMIPlans,
  }))
  return <EMIPlans plans={getEMIPlans(EMIPaymentType.CREDIT_CARD_ALL)} />
}

const EMIEligibilityFooter = ({ title, onClick }: { title: string; onClick: () => void }) => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))

  const style = styles(theme)

  return (
    <Box marginBottom={10} marginTop={5}>
      <Box
        flexDirection="row"
        underlayColor={theme?.bodyBgColor as ColorOptions}
        justifyContent="space-between"
        onPress={onClick}>
        <Text {...style.emiPlansEligibleText}>{title}</Text>
      </Box>
    </Box>
  )
}

const EMINotEligibileFooter = () => {
  const { theme } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
  }))
  const style = styles(theme)
  return (
    <Box paddingVertical={5}>
      <Box flexDirection="row" justifyContent="space-between">
        <Text {...style.text}>Card not eligibile for emi, choose an another card</Text>
      </Box>
    </Box>
  )
}

const styles = (theme: any) => ({
  container: {
    flex: 1,
    backgroundColor: theme?.bodyBgColor as ColorOptions,
    paddingVertical: THEME_PADDING.VERTICAL_PADDING,
    overflowY: 'auto',
  } as BoxProps,
  allEMIPlansData: {
    fontSize: 12,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  emiPlansEligibleText: {
    fontSize: 12,
    color: theme?.brandColor as ColorOptions,
    fontWeight: '700',
    textDecorationLine: 'underline',
  } as TextProps,
  text: {
    fontSize: 14,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  emiOffer: {
    fontSize: 10,
    fontWeight: 'bold',
    color: theme?.brandColor as ColorOptions,
  } as TextProps,
  payWithOutText: {
    fontSize: 14,
    color: convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions,
    fontWeight: '700',
  } as TextProps,
  emiPlans: {
    fontSize: 14,
    color: theme.brandColor as ColorOptions,
    fontWeight: '700',
    textDecorationLine: 'underline',
  } as TextProps,
  listItemHeading: {
    height: 56,
    paddingVertical: 20,
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: theme.bodyBgColor as ColorOptions,
    alignItems: 'center',
  } as BoxProps,
  headerText: {
    fontSize: 12,
    color: theme?.bodyTextColor as ColorOptions,
    fontWeight: '700',
    textAlign: 'center',
  } as TextProps,
  listData: {
    padding: 16,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 5) as ColorOptions,
    flexDirection: 'row',
    justifyContent: 'space-between',
  } as BoxProps,
  separatorStyle: {
    height: 1,
    backgroundColor: convertHexToRGBA(theme?.bodyTextColor, 10) as ColorOptions,
  } as BoxProps,
})
export default EMI
